import React from 'react';

import isItemActive from '../../utils/isItemActive'

import sectionStyles from './Section.module.scss'


function Section(props) {
    return (
        <div>
            <button
                className = {props.isActive ? sectionStyles.sectionButtonActive : sectionStyles.sectionButton}
                onClick = {props.onSectionTitleClick}
            >
                <div className = {props.isActive ? sectionStyles.arrowDown : sectionStyles.arrowRight}></div>
                {props.section.title}
            </button>
            <ul className = {sectionStyles.sectionElementContainer} style = {{display: props.isActive ? 'block' : 'none'}}>
                {props.section.items && props.section.items.map((item, index) => (
                    <li className = {sectionStyles.sectionElement} key = {item.id}>
                        {props.createLink({
                            isActive: isItemActive(props.location, item, props.section.id),
                            id: props.section.id,
                            item: item,
                            location: props.location,
                        })}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Section;
